import axios from "axios";
import { API_BASE_URL } from "./BaseURL";


const UserService = {

  createUser: async (userData, file) => {
   
    try {
      const formData = new FormData();
      
     
      Object.keys(userData).forEach(key => {
        if (typeof userData[key] === 'object') {
          formData.append(key, JSON.stringify(userData[key]));
        } else {
          formData.append(key, userData[key]);
        }
      });
      
     
      if (file) {
        formData.append('picture', file);
      }

      const response = await axios.post(`${API_BASE_URL}/users`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;

      
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getAllUsers: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users`, {
        params: {
          page: params.page || 1,
          limit: params.limit || 10,
          search: params.search || '',
          category: params.category || '',
          role: params.role || '',
          isActive: params.isActive || '',
          resigned: params.resigned || '',
          sortBy: params.sortBy || 'createdAt',
          sortOrder: params.sortOrder || 'desc'
        }
      });
      console.log(response)
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getUserById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  searchUsers: async (searchTerm) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/search`, {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  updateUser: async (id, userData, file) => {
    console.log(id)
    try {
      const formData = new FormData();
      
   
      Object.keys(userData).forEach(key => {
        if (typeof userData[key] === 'object') {
          formData.append(key, JSON.stringify(userData[key]));
        } else {
          formData.append(key, userData[key]);
        }
      });
      
      if (file) {
        formData.append('picture', file);
      }

      const response = await axios.put(`${API_BASE_URL}/users/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

 
  deleteUser: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/users/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getUserStats: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/stats`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  updateUserSalary: async (id, salaryData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/users/${id}/salary`, salaryData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  markAsResigned: async (id, resignationData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/users/${id}/resign`, resignationData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getActiveEmployees: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/active`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getResignedEmployees: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/resigned`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },


  getSalarySummary: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/users/salary-summary`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
 
  getTotalSimpleCounts : async()=>{
    try {
      const response = await axios.get(`${API_BASE_URL}/users/stats/total-counts`)
      return response.data;
    } catch (error) {
       throw error.response?.data || error;
    }
  }
  
};

export default UserService;